"use client"
import { useIsDesktop } from "common/MediaQueries"
import InnerPageWrapper from "../../../reusable/wrappers/InnerPageWrapper"
import CarFleetForm from "./CarFleetForm"

const CarFleetPage = () => {
  const isDesktop = useIsDesktop()
  return (
    <>
      <InnerPageWrapper
        title="ציי רכב"
        subtitle="אנחנו כאן כדי לוודא שעובדי ועובדות החברה ייהנו מחוויית מאזדה מושלמת."
        imgUrl={
          isDesktop
            ? "/img/cover/VehicleFleet.jpg"
            : "/img/cover/VehicleFleetmobile.jpg"
        }
        breadCrumbName="CarFleets"
      >
        <CarFleetForm />
      </InnerPageWrapper>
    </>
  )
}

export default CarFleetPage
